import Panel from './Panel.vue'
import List from './List.vue'
import ListItem from './ListItem.vue'
import ListItemTitle from './ListItemTitle.vue'
import Tree from './Tree.vue'
import TreeSelected from './TreeSelected.vue'
import ImportantLine from './ImportantLine.vue'
import ISelect from './ISelectSimple.vue'
import ISelectMultiple from './ISelectMultiple.vue'

export default {
  install (Vue) {
    Vue.component('list', List)
    Vue.component('list-item', ListItem)
    Vue.component('list-item-title', ListItemTitle)
    Vue.component('panel', Panel)
    Vue.component('tree', Tree)
    Vue.component('tree-selected', TreeSelected)
    Vue.component('important-line', ImportantLine)
    Vue.component('i-select', ISelect)
    Vue.component('i-select-multiple', ISelectMultiple)
  }
}



// WEBPACK FOOTER //
// ./src/ui/index.js